<template>
  <div class="itemList">
    <div class="topBtnWrap">
      <div class="itemtitle">{{groupName}}</div>
    </div>
    <div class="itemContent">
      <div v-if="program.length !== 0">
        <div class="programs" v-for="(item,index) in program" :key="index">
          <div class="program-item">
            <div class="program-item-img">
              <img  src="/static/images/1234.png" style="width: 100%;height: 100%;">

            </div>
            <div class="program-item-text overtext">
              <div class="program-item-name overtext">{{item.pmName}}</div>
              <div class="program-item-list">{{$t('append_field.modification_time')}}:<br>{{item.createTime}}</div><br>
              <div class="program-item-list">{{$t('append_field.resolution_')}}: {{item.resolution}}</div>
              <div class="program-item-list">{{$t('append_field.associated_tasks')}}: {{item.bindTaskNum}}</div>
              <div class="program-item-operate">
                <div class="program-item-btns"
                     @click="gotoa(`/createProrram`,{
                      id:item.id,
                      type:'edit'
                      })">
                  <i class="etv etvicon etv-bianji"></i>
                </div>
                <div class="program-item-btns" @click="gotoa(`/preview`,{
                      id:item.id
                      })">

                  <i class="etv etvicon etv-yulan"></i>
                </div>
                <div class="program-item-btns" @click="gotoa(`/addTask`,{
                      grogramIds:item.id,
                      parentPage:'taskList',
                      progremData: [item]
                      })">
                  <i class="etv etvicon etv-fasong"></i>
                </div>
                <div class="program-item-btns" @click="delprogram(item.id,index,item.bindTaskNum)">
                  <i class="etv etvicon etv-shanchu"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="empty" v-if="program.length === 0">
        {{$t('append_field.no_data')}}
      </div>
    </div>
<!--    删除显示绑定的任务列表-->
    <van-popup v-model="isVisible1" position="bottom" custom-style="height: 20%" class="popupBottom">
      <van-row class="popupHead">
        <van-col :span="4">
          <van-button @click="isVisible1 = false" color="#FF5700" size="small" class="popupHead-l" >
            {{$t('append_field.cancel')}}
          </van-button>
        </van-col>
        <van-col :span="16" style="text-align: center">{{$t('append_field.bound_task')}}</van-col>
        <van-col :span="4">
          <van-button @click="deleteConfirm" color="#FF5700" size="small"  class="popupHead-r" >
            {{$t('append_field.delete')}}
          </van-button>
        </van-col>
      </van-row>
      <div style="height:300px;overflow-y: auto;text-align: center" class="popupCenter">
        <div v-show="noData" class="nodataTxt">{{$t('append_field.no_data')}}</div>
        <van-row>
<!--          <van-col v-show="!noData" span="6">任务名称：</van-col>-->
          <van-col v-show="!noData" span="24" v-for="(item,index) in menuItems2" :key="index" >{{item.name}}</van-col>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import qs from 'qs'
  import { Dialog, Toast } from 'vant'


  export default {
    inject: ['reload'],
    data() {
      return {
        program: [],
        groupName: '',
        modal: false,
        button6: [{
          text: this.$t('append_field.cancel'),
          type: 'gray',
        }, {
          text: this.$t('append_field.confirm'),
        }],
        delObj: {
          id: '',
          index: 0,
        },
        groupId: 0,
        Pname: '',
        eventSign: 'click',
        contentTexe: this.$t('append_field.confirm_delete_program'),
        isVisible1: false,
        menuItems2: [],
        noData: true,

      }
    },
    mounted() {
      this.getprogram()
      this.groupName = this.$route.query.name
    },
    methods: {
      ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
      getprogram() {
        this.$ajax.post('/etv/selectPhoneLstProgramMould.json', qs.stringify({
          pcId: this.$route.query.id,
          state: 0,
          pageSize: 12,
          pageNum: 1,
          name: '',
        })).then(res => {
          if (res.data.code === 0) {
            this.program = res.data.data
          }
        })
      },
      // eslint-disable-next-line no-unused-vars
      goto(url) {

      },

      gotoa(url, query) {
        this.$router.push({
          path: url,
          query,
        })
        if (url == '/addTask') {
          this.changeTopTitle(this.$t('append_field.addTask'))
          this.setParentPage('programs')
          this.changeTopIconStatus(true)
        }
      },

      // delprogram(id, index, number) {
      delprogram(id,index,num) {
        if(!parseInt(num)){
          this.delObj.id = id
          this.deleteConfirm()
          return
        }
        let _this = this
        _this.isVisible1 = true
        _this.delObj.id = id
        this.$ajax.post('/etv/selectProgramMouldBindEqtask.json',qs.stringify({
          id: id
        })).then(res => {
          if(res.data.data.length > 0){
            _this.noData = false
            _this.menuItems2 = res.data.data
          }else{
            _this.noData = true
          }
        })

      },
      deleteConfirm(){
          let contentTexe = this.$t('append_field.confirm_delete_this_program')
          this.isVisible1 = false
          // if (number !== 0) {
          //   contentTexe = this.$t('append_field.bound_tasks_exists_confirm_delete')
          // } else {
          //   contentTexe = this.$t('append_field.confirm_delete_program')
          // }
          // this.delObj = {
          //   id,
          //   index,
          // }


          Dialog.confirm({
            title: this.$t('append_field.prompt'),
            message: contentTexe,
          }).then(() => {
            this.$ajax.post('/etv/deleteProgramMouldById.json', qs.stringify({
              id: this.delObj.id,
            })).then(res => {
              if (res.data.code === 0) {
                Toast(this.$t('append_field.delete_success'))
                this.reload()
              } else {
                Toast(this.$t('append_field.delete_failed'))
              }
            })
          }).catch(() => {
            // on cancel
          })
      },
      hide() {
        this.modal = false
      },

    },
    computed: {
      ...mapState({
        progranList: state => state.progranList,
      }),
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";

  .itemList {
    position: absolute;
    left: 0;
    top: 0px;
    right: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;

    .popupBottom{
      .popupHead{
        height:40px;line-height:40px;border-bottom:1px solid #ddd;
        .popupHead-l{
          width:100%;background:none;color:#EE0A24;border:none;line-height:40px;height:40px;text-indent: -4px;
        }
        .popupHead-r{
          width:100%;background:none;color:#006EFF;border:none;line-height:40px;height:40px;text-indent: -4px;
        }
      }
      .popupCenter{
        min-height:150px;max-height:200px;overflow-y: auto;text-align: center;padding:0 20px;
        .van-col{
          text-align: center;width:100%;height:40px;line-height:40px;border-bottom:1px solid #ddd;
        }
        .nodataTxt{
          margin-top:30%;
          width:100%;
          text-align: center;
        }
      }
    }



    .topBtnWrap {
      display: flex;
      justify-content: center;
      width: 100%;

      .itemtitle {
        display: flex;
        flex: 1;
        justify-content: center;
        margin: 0;
        height: 45px;
        line-height: 45px;
        background: #FFF;

        color: #000;
      }
    }

    .itemContent {
      height: calc(100% - 45px);
      overflow-y: auto;
      width: 100%;
    }

    .empty {
      height: 100px;
      width: 100%;
      text-align: center;
      line-height: 100px;
      color: #8c8c8c;
    }

    .programs {
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      background: $uni-text-color-inverse;
      margin-top: 13px;

      .program-item {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        border-radius: 5px;

        .program-item-img {
          height: 123px;
          width: 110px;
          box-sizing: border-box;
        }

        .program-item-text {
          flex: 1;
          padding-left: 15px;
          box-sizing: border-box;

          .program-item-name {
            height: 20px;
            border-bottom: 2 upx solid $uni-border-bottom-color;
            color: #007AFF;
            font-size:  15px;
            margin-bottom: 5px;
          }

          .program-item-list {
            height: 20px;
            line-height: 20px;
            font-size:  15px;
            margin: 3px 0;
            color: $uni-text-color-placeholder;
          }

          .program-item-operate {
            display: flex;
            justify-content: space-between;
            width: 150px;
            margin-top: 9px;

            .program-item-btns {
              height: 24px;
              width: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #e7e7e8;
              border-radius: 3px;

              text {
                color: #6b6b6b;
              }
            }
          }
        }
      }

    }
  }
</style>
